import type { IPageManagerConfig } from '~/features-generic/config-manager/interfaces/page-manager'
import { IPageManagerMode } from '~/features-generic/config-manager/interfaces/page-manager'

import type { RoutesName } from '~/typings/vue-router'

interface IPageManagerExport { default: IPageManagerConfig }

const MANAGER_MODULES = import.meta.glob<false, '', IPageManagerExport>('~/config/pages-manager/*.ts')
const DEFAULT_MANAGER: T_PAGE_MANAGER_ALLOW_LIST = 'swym-standalone'
export type T_PAGE_MANAGER_ALLOW_LIST =
'swym-standalone' | 'swym-widget' | 'home-by-me' | 'content-reader' | 'profile-widget'

export const PAGE_MANAGER_ALLOW_LIST: T_PAGE_MANAGER_ALLOW_LIST[] = [
  'swym-standalone',
  'swym-widget',
  'home-by-me',
  'content-reader',
  'profile-widget',
]
export const PAGE_MANAGER_NAME = ref<T_PAGE_MANAGER_ALLOW_LIST>(DEFAULT_MANAGER)
export const PAGE_MANAGER_MODE = ref<IPageManagerMode>(IPageManagerMode.DENY)
const PageManager: RoutesName[] = []

function getManagerModule(managerName: T_PAGE_MANAGER_ALLOW_LIST) {
  const [,manager] = (Object
    .entries(MANAGER_MODULES)
    .find(([key]) => key.endsWith(`${managerName}.ts`)) || [])

  if (!manager)
    throw new Error(`Manager ${managerName} not found.`)

  return manager()
}

/**
 * Initialize the page manager
 * @description It will fetch the manager configuration
 * @param managerName Manager name to load
 * @default
 */
export async function initPageManager(managerName = PAGE_MANAGER_NAME.value) {
  if (!PAGE_MANAGER_ALLOW_LIST.includes(managerName))
    return

  const { default: manager } = await getManagerModule(managerName)

  if (Object.prototype.hasOwnProperty.call(manager, 'pages') && Array.isArray(manager.pages))
    PageManager.push(...manager.pages)

  PAGE_MANAGER_MODE.value = manager?.mode ?? IPageManagerMode.DENY
  PAGE_MANAGER_NAME.value = managerName
}

/**
 * Check if the manager allows the access to the given page
 * @param pageName route.name of the page you want to check the access
 * @returns boolean
 */
export function hasAccessTo(pageName: RoutesName) {
  const isPageListed = PageManager.includes(pageName)
  return PAGE_MANAGER_MODE.value === IPageManagerMode.DENY ? !isPageListed : isPageListed
}
